import { Button, Spinner } from 'react-bootstrap';
import { useLocaleContext } from '../../i18n';

interface Props {
  onBack?: () => void;
  onNext?: () => void;
  nextLabel?: string;
  onAction?: () => void;
  actionLabel?: string;
  loading?: boolean;
  disabled?: boolean;
}

export default function PlannerNavigation({ onBack, onNext, nextLabel, onAction, actionLabel, loading = false, disabled = false }: Props) {
  const { locale } = useLocaleContext();

  return (
    <div className="planner-button-container">
      {onBack ? (
        <button onClick={onBack} className="planner-button-back">
          {locale.planner.back}
        </button>
      ) : (
        <div style={{ flex: '0 0 auto' }} />
      )}
      {onAction ? (
        <Button
          variant="success"
          onClick={onAction}
          disabled={loading || disabled}
          className="planner-button-next"
        >
          {actionLabel || 'Akcja'}
        </Button>
      ) : onNext && (
        <Button
          variant="primary"
          onClick={onNext}
          disabled={loading || disabled}
          className="planner-button-next"
        >
          {loading ? <><Spinner size="sm" className="me-2" />Loading...</> : (nextLabel || locale.planner.nextStep)}
        </Button>
      )}
    </div>
  );
}
